module.exports = __webpack_public_path__ + "static/media/icon_radio.9c5901dc.svg";